import { Routes } from '@angular/router';
import { VpVerifyComponent } from './components/verification/vp-verify/vp-verify.component';
import { PdfDocumentType, PdfViewAcceptComponent } from './components/verification/pdf-view-accept/pdf-view-accept.component';
import { VpLandingComponent } from './components/landing-page/vp-landing/vp-landing.component';
import { BewerbungEingereichtComponent } from './components/bewerbung-eingereicht/bewerbung-eingereicht.component';
import { BewerbungEinreichenComponent } from './components/bewerbung/bewerbung-einreichen/bewerbung-einreichen.component';
import { AnmeldeschlussAbgelaufenComponent } from './components/anmeldeschluss-abgelaufen/anmeldeschluss-abgelaufen.component';
import { anmeldeschlussAbgelaufenGuard } from './infrastructure/guards/anmeldeschluss-abgelaufen.guard';
import { bewerbungEingereichtGuard } from './infrastructure/guards/bewerbung-eingereicht.guard';
import { verifyResultGuard } from './infrastructure/guards/verify-result.guard';
import { tokenGuard } from './infrastructure/guards/token.guard';
import { RedirectGuard, redirectGuard, RedirectGuardData } from './infrastructure/guards/redirect.guard';
import { AnmeldungGeloeschtComponent } from './components/anmeldung-geloescht/anmeldung-geloescht.component';

export const routes: Routes = [
  {
    path: `vp/:token`,
    component: VpVerifyComponent
  },
  {
    path: 'vp/:token/datenschutz',
    component: PdfViewAcceptComponent,
    canActivate: [tokenGuard],
    data: {
      pdfUrl: 'Datenschutzeinwilligung.pdf',
      pdfDocumentType: PdfDocumentType.DATENSCHUTZEINWILLIGUNG
    }
  },
  {
    path: 'vp/:token/verschwiegenheit',
    component: PdfViewAcceptComponent,
    canActivate: [tokenGuard],
    data: {
      pdfUrl: 'Verschwiegenheitsverpflichtung.pdf',
      pdfDocumentType: PdfDocumentType.VERSCHWIEGENHEITSVERPFLICHTUNG
    }
  },
  {
    path: `vp/:token/landing`,
    component: VpLandingComponent,
    canActivate: [verifyResultGuard]
  },
  {
    path: 'vp/:token/cv',
    component: BewerbungEinreichenComponent,
    canActivate: [verifyResultGuard, bewerbungEingereichtGuard, anmeldeschlussAbgelaufenGuard]
  },
  {
    path: 'vp/:token/bewerbung-eingereicht',
    component: BewerbungEingereichtComponent,
    canActivate: [verifyResultGuard]
  },
  {
    path: 'vp/:token/anmeldeschluss-abgelaufen',
    component: AnmeldeschlussAbgelaufenComponent,
    canActivate: [verifyResultGuard]
  },
  {
    path: 'vp/:token/anmeldung-geloescht',
    component: AnmeldungGeloeschtComponent,
    canActivate: [verifyResultGuard]
  },
  {
    path: '**',
    canActivate: [redirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://www.taures.de/'
    } satisfies RedirectGuardData
  }
];
